export const USER = {
  LOGIN: '/api/v1/user/login',
  CHANGE_PASSWORD: '/api/v1/user/reset-password',
  UPDATE_ACCESS_TOKEN: '/api/v1/user/token',
  VERIFY_RESET_PASSWORD_TOKEN: '/api/v1/user/reset-password-token-verify',
};

export const RETAILERS = {
  RETAILERS: '/api/v1/retailer/list',
  RETAILER: '/api/v1/retailer',
  RETAILER_RESET_PASSWORD: '/api/v1/retailer/password-reset-email',
  RETAILERS_STATS: '/api/v1/retailer/get-stats',
  RETAILERS_GRAPH: '/api/v1/retailer/analytics',
  ADMIN_STATS: '/api/v1/retailer/admin-stats',
  POLICIES_LEDGER: '/api/v1/retailer/policies-ledger',
};

export const COMPANY = {
  COMPANY: '/api/v1/company',
};
